import {
    Button, makeStyles,
    Typography
} from "@material-ui/core";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import CustomMarkdown from "../../component/CustomMarkdown";
import TemplateComponent from "../../component/template/TemplateComponent";
import { BillerModel } from "../../models/BillerModel";
import { RootState } from "../../store";
import {
    defaultWidth,
    fontUnit
} from "../../utils/DeviceManager";

const copy = require("clipboard-copy");

export function OtherBank() {
    const classes = useStyles();

    const billerInfo: BillerModel = useSelector(
        (state: RootState) => state.billerReducer.billInfo
    );

    useEffect(() => {
        window.document.title = "ชำระเงิน";
    }, []);

    const dynamicFont = (num: number, amount: string) => {
        const lng = amount.length;
        if (lng <= 14) return num;
        const lvl = (defaultWidth * 0.7) / (lng * 0.60);
        if (lvl >= num) return num;
        return lvl;
    };

    const otherBank = () => {
        return (
            <div className={classes.root}>
                <Typography style={{ fontWeight: 600, margin: "24px" }}>
                    แอปฯ ธนาคารอื่น
                </Typography>
                <div className={classes.card}>
                    {billerInfo.billerCodeId && (
                        <div className={classes.content}>
                            <Typography style={{ color: AcnColorTheme.darkGrey }}>
                                รหัสผู้ให้บริการ
                            </Typography>
                            <div className={classes.linenumber}>
                                <Typography
                                    style={{
                                        fontFamily: "Helvetica",
                                        fontSize: fontUnit(
                                            dynamicFont(36, billerInfo.billerCodeId)
                                        ),
                                    }}
                                    data-testid="billId"
                                >
                                    {billerInfo.billerCodeId}
                                </Typography>
                                <Button
                                    color="primary"
                                    className={classes.copy}
                                    data-testid="copyBtn"
                                    onClick={() => {
                                        copy(billerInfo.billerCodeId);
                                    }}
                                >
                                    คัดลอก
                                </Button>
                            </div>
                        </div>
                    )}
                    {billerInfo.ref1 && (
                        <div className={classes.content}>
                            <Typography style={{ color: AcnColorTheme.darkGrey }}>
                                หมายเลขอ้างอิง 1
                            </Typography>
                            <div className={classes.linenumber}>
                                <Typography
                                    style={{
                                        fontFamily: "Helvetica",
                                        fontSize: fontUnit(dynamicFont(36, billerInfo.ref1)),
                                    }}
                                    data-testid="ref1"
                                >
                                    {billerInfo.ref1}
                                </Typography>
                                <Button
                                    color="primary"
                                    className={classes.copy}
                                    data-testid="copyBtn"
                                    onClick={() => {
                                        copy(billerInfo.ref1);
                                    }}
                                >
                                    คัดลอก
                                </Button>
                            </div>
                        </div>
                    )}
                    {billerInfo.ref2 && (
                        <div className={classes.content}>
                            <Typography style={{ color: AcnColorTheme.darkGrey }}>
                                หมายเลขอ้างอิง 2
                            </Typography>
                            <div className={classes.linenumber}>
                                <Typography
                                    style={{
                                        fontFamily: "Helvetica",
                                        fontSize: fontUnit(dynamicFont(36, billerInfo.ref2)),
                                    }}
                                    data-testid="ref2"
                                >
                                    {billerInfo.ref2}
                                </Typography>
                                <Button
                                    color="primary"
                                    className={classes.copy}
                                    data-testid="copyBtn"
                                    onClick={() => {
                                        copy(billerInfo.ref2);
                                    }}
                                >
                                    คัดลอก
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
                <div className={classes.footer}>
                    <Typography style={{ fontWeight: 600 }}>วิธีชำระเงินผ่านแอปธนาคารอื่น ๆ</Typography>
                    <Typography className={classes.markdownText}>
                        <CustomMarkdown
                            content={
                                "<ol>" +
                                "<li><span>ไปหน้าชำระเงินในแอปพลิเคชันของธนาคารที่คุณต้องการ</span></li>" +
                                "<li><span>ชำระเงินโดยใช้รหัสผู้ให้บริการ และหมายเลขอ้างอิง 1 ตามขั้นตอนและวิธีการที่กำหนดใน แอปพลิเคชันของธนาคารดังกล่าว</span></li>" +
                                "</ol>"
                            }
                        />
                        หากคุณมีข้อสงสัย หรือมีความประสงค์จะสอบถามข้อมูลอื่นใดเพิ่มเติม โปรดติดต่อฝ่ายบริการลูกค้า
                        <br/>โทร. 02-777-7333 หรือไปที่สาขาไชโยใกล้บ้าน
                    </Typography>
                </div>
            </div>
        );
    };

    return <TemplateComponent noPadding content={otherBank()} />;
}

const useStyles = makeStyles({
    root: {
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        overflow: "hidden",
    },
    card: {
        padding: "40px 0px",
        backgroundColor: AcnColorTheme.white,
        width: "100vw"
    },
    content: {
        padding: "0 16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        '&:not(:first-child)': {
            paddingTop: 32
        }
    },
    copy: {
        borderRadius: "16px",
        background: AcnColorTheme.secondaryRed,
        height: "32px",
        color: "white",
        fontSize: "16px",
        "&:hover": {
            background: AcnColorTheme.secondaryRed,
        },
        "&:active": {
            background: AcnColorTheme.secondaryRed,
            opacity: 0.5,
        }
    },
    linenumber: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: 'space-between',
        width: "100%",
    },
    footer: {
        marginTop: '40px',
        marginBottom: '60px',
        padding: "0 16px",
        color: AcnColorTheme.black,
        textAlign: 'left'
    },
    markdownText: {
        fontFamily: "Thonburi",
        fontSize: 16,
    }
});
